import $ from 'jquery'
import { toolkitUrls, pathwaysUrls } from '@/links'
import { defaultMemoryCache, ajaxCacheWrapper } from './cache'

export { getGoalByUuid, getGoalBySlug, getStaircaseForContent, shareGoal, unshareGoal, translateGoalText }

function getGoalByUuid(uuid, params = {}) {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${toolkitUrls.api}/goal/${uuid}`,
    data: params,
    method: 'GET',
    contentType: 'json',
    xhrFields: { withCredentials: true }
  })
}

function getGoalBySlug(slug, params = {}) {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${toolkitUrls.api}/goal/${slug}`,
    data: params,
    method: 'GET',
    contentType: 'json',
    xhrFields: { withCredentials: true }
  })
}

function shareGoal(uuid) {
  return $.ajax({
    url: `${toolkitUrls.api}/library/share/goal/${uuid}`,
    method: 'PUT',
    xhrFields: { withCredentials: true }
  })
}

function unshareGoal(uuid) {
  return $.ajax({
    url: `${toolkitUrls.api}/library/share/goal/${uuid}`,
    method: 'PUT',
    xhrFields: { withCredentials: true },
    data: JSON.stringify({
      unshare: true
    })
  })
}

function getStaircaseForContent(uuid, standardSetCode, subject) {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${
      toolkitUrls.api
    }/goal/${uuid}/staircase/${standardSetCode}?group=1&subject=${encodeURIComponent(subject)}`,
    method: 'GET',
    contentType: 'json',
    xhrFields: { withCredentials: true }
  })
}

function translateGoalText(uuid, text, edited, language) {
  const body = {
    goal_uuid: uuid,
    edited: edited,
    language: language
  }
  if (edited) {
    body.goal_text = text
  }
  return $.ajax({
    url: pathwaysUrls.translateGoalText,
    method: 'POST',
    contentType: 'application/json;charset=utf-8',
    xhrFields: { withCredentials: true },
    data: JSON.stringify(body)
  })
}
